import { render, staticRenderFns } from "./Alibaba-product-category.vue?vue&type=template&id=7df7aa8a&scoped=true&"
import script from "./Alibaba-product-category.vue?vue&type=script&lang=js&"
export * from "./Alibaba-product-category.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-product-category.vue?vue&type=style&index=0&id=7df7aa8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df7aa8a",
  null
  
)

export default component.exports